$(() => {
  // enterキーでvalidationとsubmitをしないようにする
  $('form input:not([type="search"])').on('keypress', event => event.which !== 13);
});
